const normalizeText = (value) => {
    if (value === null || value === undefined) return "";
    return String(value).trim();
};

export const isOtherSelection = (value) => {
    const normalized = normalizeText(value).toUpperCase();
    return normalized === "OTHER" || normalized === "OTHERS";
};

export const humanizeSelectionValue = (value) => {
    const normalized = normalizeText(value);
    if (!normalized) return "";

    if (/^[A-Z0-9_-]+$/.test(normalized)) {
        return normalized
            .replace(/[_-]+/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    }

    return normalized;
};

export const resolveOtherDisplayValue = (selectedValue, otherValue, fallback = "-") => {
    const selected = normalizeText(selectedValue);
    const other = normalizeText(otherValue);

    if (isOtherSelection(selected)) {
        return other || humanizeSelectionValue(selected) || fallback;
    }

    if (!selected && other) {
        return other;
    }

    return humanizeSelectionValue(selected) || fallback;
};

export const resolveAssetNameDisplay = (asset, fallback = "-") =>
    resolveOtherDisplayValue(
        asset?.name || asset?.asset_name || asset?.assetName,
        asset?.other_name || asset?.otherName,
        fallback
    );

export const resolveBuildingNameDisplay = (asset, fallback = "-") => {
    const selected = normalizeText(asset?.building_name || asset?.buildingName);
    const other = normalizeText(
        asset?.other_building_name ||
            asset?.otherBuildingName
    );

    if (isOtherSelection(selected)) {
        return other || fallback;
    }

    if (!selected && other) {
        return other;
    }

    return humanizeSelectionValue(selected) || fallback;
};

export const resolveRoomDisplay = (asset, fallback = "-") =>
    resolveOtherDisplayValue(
        asset?.room_name_or_number || asset?.roomNameOrNumber,
        asset?.room_others || asset?.roomOthers,
        fallback
    );

export const resolveSiteWorkTypeDisplay = (asset, fallback = "-") => {
    const selected = asset?.site_work_type || asset?.name;
    const other = asset?.other_specify || asset?.other_name || asset?.otherName;
    const base = resolveOtherDisplayValue(selected, other, fallback);

    if (!isOtherSelection(selected) && normalizeText(selected) && normalizeText(other)) {
        return `${humanizeSelectionValue(selected)} - ${normalizeText(other)}`;
    }

    return base;
};
